<template>
  <div>
    <div id="key-words-hot" style="height: 300px; width: 488px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wordData: [],
      color: ["#5470C6", "#EE6666", "#FAC858", "#91CC75"],
    };
  },
  props: ["userData"],
  watch: {
    userData: function (newVal, oldVal) {
      // console.log(this.keyWordsData)
      let data = this.userData.hot_words_result.sort((a, b) => {
        return b[1] - a[1];
      });
      data.forEach((item,index)=>{
        if(index <= 20){
          this.wordData.push({name:item[0],value:item[1]})
        }
      })
      console.log(data);
      this.createChart();
    },
  },
  mounted() {
    // this.createChart();
  },
  methods: {
    createChart() {
      let that = this;
      var chartDom = document.getElementById("key-words-hot");
      var myChart = this.$echarts.init(chartDom);
      var option;

      option = {
        shape: "cardioid",
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",
          //   formatter: "{b}用户: {c} ({d}%)",
          formatter: "{b}: {c} ",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        series: [
          {
            type: "wordCloud",
            sizeRange: [15, 100],
            rotationRange: [0, 0],
            rotationStep: 45,

            shape: "pentagon",
            width: "100%",
            height: "100%",
            gridSize: 10,
            textStyle: {
              fontFamily: "sans-serif",
              fontWeight: "bold",
              // Color can be a callback function or a color string
              color: function () {
                // Random color
                return that.color[parseInt(4 * Math.random())];
              },
            },
            emphasis: {
              focus: "self",

              textStyle: {
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            data: that.wordData,
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang="scss">
#key-words-hot {
  top: 50px;
  margin: 0 auto;
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/groupPortrait/KeyWordsHot.vue